import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";

export const useUpdateMySession = () => {
  const handleErrors = useQueryErrorHandling();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (updateData: any) => api.patch(`onboarding/session/me`, updateData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: onboardingQKeys.session() });
    },
    onError: (res: any) => {
      console.error("[From Update Session]", res);
      handleErrors(res, "mutation");
    },
  });
};
